// extracted by mini-css-extract-plugin
export var borderRadius = "_fy-4";
export var large = "_fy-3";
export var logoContainer = "_fy-0";
export var nameLogo = "_fy-2";
export var small = "_fy-1";